import React from 'react';
import { FormattedMessage } from 'react-intl';
import InputInfoCircle from 'components/InputInfoCircle';
import { Space } from 'antd';

const FormLabel = ({ label, labelValues, description, tooltipPlacement = 'top', extra }) => (
  <Space>
    {label.id ? <FormattedMessage {...label} values={labelValues} /> : label}
    {description && (
      <InputInfoCircle title={description.id ? <FormattedMessage {...description} /> : description} placement={tooltipPlacement} />
    )}
    {extra}
  </Space>
);

export default FormLabel;
